import axios from "axios";

const MUNICIPALITY_API_URL =
  process.env.REACT_APP_MUNICIPALITY_API_URL ||
  "https://xvia-portal-base-back-dev.apps.ocp.ati.pi.gov.br";

export interface MunicipalityStatistics {
  total_services: number;
  total_categories: number;
}

export interface MunicipalityItem {
  id: number;
  municipality: string;
  ibge_code: number;
  statistics: MunicipalityStatistics;
  parameters?: {
    banner_url: string | null;
    municipality_link: string | null;
  };
  updated_at: string;
}

export interface MunicipalityListMeta {
  current_page: number;
  per_page: number;
  total_records: number;
  total_pages: number;
  next_page_url?: string | null;
  prev_page_url?: string | null;
}

export interface MunicipalityListResponse {
  data: MunicipalityItem[];
  meta: MunicipalityListMeta;
}

export interface GetMunicipalitiesParams {
  page?: number;
  perPage?: number;
  search?: string;
  ibgeCode?: number;
  uf?: string;
}

export async function getMunicipalities(
  params: GetMunicipalitiesParams = {}
): Promise<MunicipalityListResponse> {
  const { page = 1, perPage = 15, search, uf = "PI" } = params;
  const { ibgeCode } = params;

  const response = await axios.get(
    `${MUNICIPALITY_API_URL}/v1/municipality/list`,
    {
      params: {
        page,
        per_page: perPage,
        search,
        ibge_code: ibgeCode,
        uf,
      },
    }
  );

  return response.data;
}
